import { user } from '@/api/service'

const state = {
    userInfo: '',
    me:'',
}
const mutations = {
    setUserInfo(state, model) {
        state.userInfo = model
    },
    setMe(state, model) {
        state.me = model
    },
}
const actions = {
    async fetchUserInfo({ commit }) {
        const res = await user()
        commit('setUserInfo', res)
        return res
    }
}
export default {
    namespaced: true,
    state,
    mutations,
    actions,
};